<template>
    <div class="gits-container">
        <nav class="sub-tab top-button-show" v-if="activeCategory==='coupon' && $public.notNull(couponList) && couponList.length>0">
            <a :class="{'active':filter===1}" @click="clickSortBy(1)">最新取得</a>
            <a :class="{'active':filter===0}" @click="clickSortBy(0)">最快到期</a>
        </nav>

        <!--TODO 優惠卷清單-->
        <div class="no-data" v-if="couponList.length===0 && activeCategory==='coupon'">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <!--todo 禮包加上樣式 giftPack-->
        <div class="gift-coupon-item" v-show="activeCategory==='coupon'" v-for="(item, index) in couponList"
             :key="'couponList'+index"
             :class="{'giftPack':item.offersType === ticketType.GiftPack.id}"
             @click="goCoupon(item)">
            <!--todo 已讀時數量加上樣式read -->
            <span class="sticker-num" :class="{ read : !item.isRead}">{{item.count}}</span>
            <div class="left">
                <span class="coupon-type" :title="item.typeName">
                    {{item.typeName}}
                </span>
                <el-image class="coupon-cover" :src="item.titleImage" fit="cover" lazy>
                    <div slot="error" class="image-slot"/>
                </el-image>
                <div class="brand">
                    {{item.storeName}}
                </div>
            </div>
            <div class="right">
                <!--識別圖-->
                <img :src="item.logoImage"
                     class="identify-logo"
                     v-if="item.isShowLogoOnList && item.logoImage !== ''" >
              <div class="name">{{item.name}}</div>
                <div class="date" :title="item.typeName" v-if="item.packContentEndedAtList.length === 0">
                    {{ item.couponType === 6 ? `場次 ${item.stageInfo.stageFormat}` : `~${item.endAt}` }}
                </div>
                <div class="date" :title="item.typeName" v-else v-for="(packContentItem, packContentIndex) in item.packContentEndedAtList" :key="packContentIndex">
                    ~{{packContentItem}}
                </div>
                <div class="detail">
                    {{item.giftTypeName}}
                </div>
                <div class="text-right" v-show="item.isGift">
                    <el-button class="donate-btn"
                               size="mini"
                               @click.stop="goTransferCoupon(item)">
                        <img src="@/assets/images/icon-card-trans.svg">
                        轉贈
                    </el-button>
                </div>
            </div>
        </div>

        <!--TODO 活動卡清單-->
        <div class="no-data" v-if="oinCardList.length===0 && activeCategory==='oinCard'">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <template v-show="activeCategory==='oinCard'">
            <div class="coupon-card">
                <div class="card_list" v-for="(item, index) in oinCardList" :key="'oinCardList' + index">
                    <div class="coupon-top">
                        <span class="active" v-show="item.isRead">new</span>
                        <!--todo 需要續約的會員卡樣式加上not-renewed-->
                        <div class="img" @click="openOinCardPage(item)"
                             :class="{'not-renewed': item.isEnable === 0}">
                            <img :src="item.imagePath">
                        </div>
                    </div>
                    <div class="coupon-body" @click="openOinCardPage(item)">
                        <div class="name">{{item.name}}</div>
                        <!--<div class="card_list_text">
                            <img src="@/assets/images/pig.svg">
                            <div class="con">
                                <div>本週：已為您省下 <span><b
                                        class="red">{{$public.numberFormat(item.weekDiscount)}}</b>元</span>
                                </div>
                                <div>累積：已為您省下 <span><b
                                        class="red">{{$public.numberFormat(item.allDiscount)}}</b>元</span></div>
                            </div>
                        </div>-->
                        <div class="date">
                            <div>加入日期 {{item.createdAt}}</div>
                            <div>會員到期 {{item.useEndDate}}</div>
                        </div>
                        <div class="button">
                            <button @click="openOinCardPage(item)">
                                <img src="@/assets/images/icon-card-view.svg"> 查看
                            </button>
                            <!--<button>
                                <img src="@/assets/images/icon-card-trans.svg"> 轉贈
                            </button>-->
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <!--TODO 集點卡清單-->
        <div class="no-data" v-if="loyaltyCardList.length===0 && activeCategory==='loyaltyCard'">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <div class="coupon-card" v-show="activeCategory==='loyaltyCard'" v-for="(item, index) in loyaltyCardList"
             :key="'loyaltyCardList'+index">
            <span class="active" v-show="item.isRead">new</span>
            <div class="list-style"
                 @click="goCouponCard(item)">
                <el-image :src="item.imgUrl" fit="cover" class="pic3" lazy>
                    <div slot="error" class="image-slot"/>
                </el-image>
                <div class="content">
                    <p class="detail mt-2">{{item.storeName}}</p>
                    <h3 class="name">{{item.name}}</h3>
                    <p class="date2 red">到期 {{item.convertEndAt}}</p>
                </div>
                <div class="right circle">{{item.amount}}</div>
            </div>
        </div>

        <!--TODO 我的卡片清單-->
        <div class="no-data" v-if="activeCategory==='card'">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <!--<div class="coupon-card" v-show="activeCategory==='card'" v-for="(item, index) in cardList" :key="index">
            <span class="active"></span>
            <el-card class=" sticker">
                <span class="coupon-type exchange">卡</span>
                <two-column>
                    <img slot="left" v-bind:src="`${item.imagePath}`" alt="">
                    <div slot="right">
                        <ul class="info">
                            <li>自{{item.startAt}} - {{item.endAt}} 止</li>
                            <li>{{item.brandName}}</li>
                        </ul>
                        <p class="name">{{item.name}}</p>
                    </div>
                </two-column>
            </el-card>
        </div>-->

        <!--TODO 紅利點數清單-->
        <div class="no-data" v-if="rewardPointList.length === 0 && activeCategory === 'rewardPoint'">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <div class="coupon-card" v-show="activeCategory === 'rewardPoint'">
            <div class="bonus-points-item" v-for="(item, index) in rewardPointList" :key="index">
                <div class="brand">
                    <span>{{item.storeName === "" || item.storeName === " " ? item.brandName : item.brandName + " "+ item.storeName}}</span>
                </div>
                <div class="list-style" @click="goBonusPointsPage(item)">
                    <el-image :src="item.imgUrl" fit="cover" class="pic3" lazy>
                        <div slot="error" class="image-slot"/>
                    </el-image>
                    <div class="content">
                        <p class="detail">{{item.name}}</p>
                        <div class="point">
                            <span class="big mr-1">{{$public.numberFormat(item.point)}} </span>點
                        </div>
                    </div>

                    <div class="expiringPoint" v-if="item.expiringPoint > 0">即將到期 {{$public.numberFormat(item.expiringPoint)}} 點</div>

                    <el-button class="donate-btn"
                               size="mini"
                               @click.stop="goTransferBonusPoints(item)"
                               v-if="item.giftLimitType !== 1"
                    >
                        <img src="@/assets/images/icon-card-trans.svg">
                        轉贈
                    </el-button>
                </div>
            </div>
        </div>

        <div v-show="!isOinCardPage">
            <infinite-loading v-if="setupListData" spinner="waveDots" @infinite="getListScroll" :distance="200">
                <div slot="no-more">沒有更多資料</div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>

        <!--網頁用-->
        <PullDownClose v-if="isShowPullDown" @close="closePullDown" class="big-pull">
            <BonusPointsPage isWeb class="content" :dataTokenWeb="dataTokenWeb" v-if="isShowPullDown && isTypeWeb==='BonusPointsPage'" @close="closePullDown"/>
            <CouponPage isWeb class="content page2" :dataTokenWeb="dataTokenWeb" v-if="isShowPullDown && isTypeWeb==='CouponPage'" @close="closePullDown" @triggerEvent="couponPageEvent"/>
            <LoyaltyCardPage isWeb class="content page2" :dataTokenWeb="dataTokenWeb" v-if="isShowPullDown && isTypeWeb==='LoyaltyCardPage'" @close="closePullDown"/>
            <OinCardPage isWeb class="content page2" :dataTokenWeb="dataTokenWeb" v-if="isShowPullDown && isTypeWeb==='OinCardPage'" @close="closePullDown"/>
        </PullDownClose>

        <!--網頁轉贈用-->
        <CommDialog :value="isShowDialog"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <TransferBonusPoints isWeb :dataTokenWeb="dataTokenWeb" @close="onCommDialogClose" class="web-content" v-if="isShowDialog && isTypeWeb==='TransferBonusPoints'"/>
            <TransferCoupon isWeb :dataTokenWeb="dataTokenWeb" @close="onCommDialogClose" class="web-content" v-if="isShowDialog && isTypeWeb==='TransferCoupon'"/>
        </CommDialog>

    </div>
</template>

<script>
    import {notNull} from '@/util/common';
    import * as mutationTypes from "@/store/mutationTypes";
    import * as constDefine from "@/store/constDefine";
    import PullDownClose from "@/components/PullDownClose";
    import BonusPointsPage from "@/views/gift/BonusPointsPage";
    import TransferBonusPoints from "@/views/gift/TransferBonusPoints";
    import CouponPage from "@/views/gift/CouponPage";
    import TransferCoupon from "@/views/gift/TransferCoupon";
    import LoyaltyCardPage from "@/views/gift/LoyaltyCardPage";
    import CommDialog from '@/components/CommDialog.vue';
    import OinCardPage from "@/views/gift/OinCardPage";
    import {updateFilterStoreId, setLineWebModeOn} from '@/store/mutationTypes';

    const isCouponRecordNear = 0;
    const isLoyaltyCardRecordNear = 0;

    const SORT_BY_END_DATE = 0;
    const SORT_BY_GOT_DATE = 1;
    const ORDER_ASC = 0;
    const ORDER_DESC = 1;

    export default {
        name: "UseItem",
        components: {
            PullDownClose,
            BonusPointsPage,
            TransferBonusPoints,
            CouponPage,
            TransferCoupon,
            LoyaltyCardPage,
            CommDialog,
            OinCardPage,
        },
        props: {
            valueType: {},
            isOinCardPage: {
              type: Boolean,
              default: false,
            },
            goToPageCardId: {type: Number, default: 0},     //預設要跳到詳細資訊頁面的卡片id
            executeType: {type: String, default: ""},
            isWeb: {default: false},
        },
        data() {
            return {
                isLoading: false,
                activeCategory: this.valueType,
                setupListData: false,
                setupRecordData: false,
                infiniteLoadingListState: '',
                infiniteLoadingRecordState: '',
                ticketType: {...constDefine.TicketType},

                //活動卡相關
                oinCardOffset: 0,
                oinCardPageSize: 10,
                oinCardList: [],
                isOinCardReadCount: 0,

                //優惠卷相關
                couponOffset: 0,
                couponPageSize: 10,
                couponRecordOffset: 0,
                couponRecordPageSize: 10,
                couponRecordSortType: isCouponRecordNear,
                couponRecordSortText: '由近到遠',
                couponList: [],
                couponRecordList: [],
                isCouponReadCount: 0,

                //集點卡相關
                loyaltyCardOffset: 0,
                loyaltyCardPageSize: 10,
                loyaltyCardRecordOffset: 0,
                loyaltyCardRecordPageSize: 10,
                loyaltyCardRecordSortType: isLoyaltyCardRecordNear,
                loyaltyCardRecordSortText: '由近到遠',
                loyaltyCardList: [],
                loyaltyCardRecordList: [],
                isLoyaltyCardReadCount: 0,

                //卡片相關
                cardOffset: 0,
                cardPageSize: 10,
                cardRecordOffset: 0,
                cardList: [],
                cardRecordList: [],
                isCardReadCount: 0,

                //紅利點數相關
                rewardPointOffset: 0,
                rewardPointPageSize: 10,
                rewardPointRecordOffset: 0,
                rewardPointList: [],
                rewardPointRecordList: [],
                isRewardPointReadCount: 0,

                isGoToPageOpened: false,

                //篩選使用
                filter: SORT_BY_GOT_DATE,
                order: ORDER_DESC,


                isShowPullDown: false,
                dataTokenWeb: '',
                isTypeWeb: '',
                isShowDialog: false,
                filterStoreId: null, //篩選出某一家店的資料

                removeSubscribe: null,
            }
        },
        created() {
            //注意！ 此頁面的寫法會在切換項目 (票券->集點卡) 或頁籤 (從記錄->可使用) 時，會重新 created 和 mounted，造成所有變數重設
            let self = this;
            //取得要單獨過濾的店家ID，line@ web版頁面用
            if (self.isWeb) {
                self.removeSubscribe = self.$store.subscribe((mutation, state) => {
                    if (mutation.type === updateFilterStoreId) {
                        self.resetByLineWeb();
                    }
                });
            }
        },
        beforeDestroy() {
            if (this.removeSubscribe) {
                this.removeSubscribe();
            }
        },
        mounted() {
            if (this.isWeb) {
                this.resetByLineWeb();

                if (localStorage.getItem('openScanType') === constDefine.OpenScanType.WebStoreCoupon) {
                    //NOTE 不用清掉 executeScanInfo 是避免又需要用到，是否執行由 openScanType 決定
                    let executeScanInfoStr = localStorage.getItem('executeScanInfo')
                    if (executeScanInfoStr !== null) {
                        let executeScanInfo = JSON.parse(executeScanInfoStr)
                        if (executeScanInfo.event === 'goCoupon') {
                            this.goCoupon(executeScanInfo.item)
                        }
                    }
                    localStorage.removeItem('openScanType')
                }
            } else {
                this.setupData()
            }
        },
        activated () {
          //避免推播點擊時未正常執行
          setTimeout(()=>{
            if (!notNull(this.$store.state.pageSnapshot["oinCardPage"])) {
              this.typeChanged(this.valueType)
            } else {
              this.$store.commit("savePageSnapshot",{routeName: "oinCardPage", variable: undefined});
            }
          },100)
        },
        methods: {
            setupData() {
                //避免推播點擊時未正常執行
                setTimeout(() => {
                    if(this.activeCategory === "coupon" && this.executeType === "couponExpirationNotice") {
                        this.clickSortBy(0)
                    } else {
                        this.typeChanged(this.valueType)
                    }
                }, 100)
            },
            typeChanged(activeCategory) {
                let self = this
                // 不管有沒有用到快照都要清掉
                this.$store.commit("savePageSnapshot",{routeName: "oinCardPage", variable: undefined});
                this.activeCategory = activeCategory
                this.clearData();
                if (this.infiniteLoadingListState !== '') {
                  setTimeout(function (){
                    self.infiniteLoadingListState.reset();
                  },100)
                } else {
                  setTimeout(function (){
                    self.setupListData = true;
                  },100)
                }
            },
            clearData() {
                this.oinCardOffset = 0;
                this.oinCardList = [];
                this.couponOffset = 0;
                this.couponList = [];
                this.loyaltyCardOffset = 0;
                this.loyaltyCardList = [];
                this.cardOffset = 0;
                this.cardList = [];
                this.rewardPointOffset = 0;
                this.rewardPointList = [];
                this.couponRecordSortType = isCouponRecordNear
                this.couponRecordSortText = '由近到遠'
                this.couponRecordOffset = 0;
                this.couponRecordList = [];
                this.loyaltyCardRecordSortType = isLoyaltyCardRecordNear
                this.loyaltyCardRecordSortText = '由近到遠'
                this.loyaltyCardRecordOffset = 0;
                this.loyaltyCardRecordList = [];
            },

            /** line@ 模式重設 */
            resetByLineWeb() {
                this.filterStoreId = this.$store.state.lineAtWebPageData.filterStoreId;
                this.clearData();
                if (this.filterStoreId > 0) {
                    this.setupData();
                }
            },

            /** 設定爲 "已讀取" */
            setupIsRead(item, giftType) {
                let self = this;
                let id = 0;
                this.$set(item, 'isRead', false);
                let searchGiftType = giftType
                switch (giftType) {
                    case 'oinCard':
                        id = item.id;
                        break;
                    case 'coupon':
                        id = item.couponId;
                        if(item.offersType === this.ticketType.GiftPack.id){
                            searchGiftType = this.ticketType.GiftPack.value
                        }
                        break;
                    case 'loyaltyCard':
                        id = item.id;
                        break;
                }

                this.$sqlite.query("select id from gift_read where gift_id = ? and type = ?", [id, searchGiftType], function (resultSet) {
                    if (resultSet.rows.length > 0) {
                        item.isRead = true;
                        switch (giftType) {
                            case 'oinCard':
                                self.isOinCardReadCount++;
                                break;
                            case 'coupon':
                                self.isCouponReadCount++;
                                break;
                            case 'loyaltyCard':
                                self.isLoyaltyCardReadCount++;
                                break;
                        }
                    }
                })
            },


            getListScroll($state) {
                this.infiniteLoadingListState = $state
                switch (this.activeCategory) {
                    case "oinCard": {
                        this.getOinCardListScroll($state);
                        break;
                    }
                    case "coupon": {
                        this.getCouponListScroll($state);
                        break;
                    }
                    case "loyaltyCard": {
                        this.getLoyaltyCardListScroll($state);
                        break;
                    }
                    case "card": {
                        this.getCardListScroll($state);
                        break;
                    }
                    case "rewardPoint": {
                        this.getRewardPointListScroll($state);
                        break;
                    }
                }
            },

            /** 取得我的活動卡清單 */
            getOinCardListScroll($state) {
                let self = this;
                this.$http.fetchWithAuth`GetMyOinCardList${{
                    offset: self.oinCardOffset,
                    searchText: self.searchKeyword,
                    filterStoreId: self.filterStoreId,
                }} ${json => {

                    if (notNull(json.data)) {
                        if (json.data.length >= self.oinCardPageSize) {
                            self.oinCardOffset++;
                            self.oinCardList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.oinCardOffset++;
                            self.oinCardList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                        self.oinCardList.forEach((item) => {
                            self.setupIsRead(item, this.activeCategory);
                        });

                        //判斷卡片裡面是否有預設要跳頁的卡？
                        if (!self.isGoToPageOpened) {
                            //第一頁裡面沒有符合的，就不再判斷
                            self.isGoToPageOpened = true;

                            for (let i=0; i<self.oinCardList.length ; i++) {
                                const item = self.oinCardList[i];
                                if (item.id === self.goToPageCardId) {
                                    self.openOinCardPage(item);
                                    break;
                                }
                            }

                            // self.oinCardList.forEach((item) => {
                            //     if (item.id === self.goToPageCardId) {
                            //         self.openOinCardPage(item);
                            //     }
                            // });
                        }

                    } else {
                        $state.complete();
                    }
                }}`;
            },

            /** 取得我的票券 */
            getCouponListScroll($state) {
                let self = this;
                //this.isLoading = true;
                this.$http.fetchWithAuth`GetMyCoupon${{
                    offset: self.couponOffset,
                    sortedBy: self.filter,
                    endSortType: self.order,
                    keyWord: self.searchKeyword,
                    filterStoreId: self.filterStoreId,
                }} ${json => {
                    //this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.couponPageSize) {
                            self.couponOffset++;
                            self.couponList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.couponOffset++;
                            self.couponList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                        self.couponList.forEach((item) => {
                            self.setupIsRead(item, this.activeCategory);
                        });

                    } else {
                        $state.complete();
                    }
                }}`;
            },

            /** 取得卡片 */
            getLoyaltyCardListScroll($state) {
                let self = this;
                //this.isLoading = true;

                //集點卡
                this.$http.fetchWithAuth`GetMyselfLoyaltyCardList${{
                    offset: self.loyaltyCardOffset,
                    searchText: self.searchKeyword,
                    filterStoreId: self.filterStoreId,
                }} ${json => {
                    //this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.loyaltyCardPageSize) {
                            self.loyaltyCardOffset++;
                            self.loyaltyCardList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.loyaltyCardOffset++;
                            self.loyaltyCardList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                        self.loyaltyCardList.forEach((item) => {
                            self.setupIsRead(item, this.activeCategory);
                        });
                    } else {
                        $state.complete();
                    }
                }}`;
            },

            /** 取得我的卡片清單 */
            getCardListScroll($state) {
                let self = this;
                //this.isLoading = true;
                this.$http.fetchWithAuth`GetMySelfCardList${{
                    offset: self.cardOffset,
                    searchText: self.searchKeyword,
                }} ${json => {
                    //this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.cardPageSize) {
                            self.cardOffset++;
                            self.cardList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.cardOffset++;
                            self.cardList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                }}`;
            },

            getRewardPointListScroll($state) {
                let self = this;
                //this.isLoading = true;
                this.$http.fetchWithAuthEncrypt`GetMyselfRewardPointList${{
                    offset: self.rewardPointOffset,
                    searchText: self.searchKeyword,
                    filterStoreId: self.filterStoreId,
                }} ${json => {
                    //this.isLoading = false;

                    if (notNull(json.data)) {
                        if (json.data.length >= self.rewardPointPageSize) {
                            self.rewardPointOffset++;
                            self.rewardPointList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            self.rewardPointOffset++;
                            self.rewardPointList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                }}`;
            },

            openOinCardPage(item) {
                let routerName = "OinCardPage"
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "cardListId": item.id,
                    "cardUserId": item.cardUserId,
                    "activeCategory": this.activeCategory,
                })
                sessionStorage.removeItem('isOinCardVisited')
                if(!this.isWeb){
                    this.$router.push({
                        name: routerName,
                        query: {dataToken: dataToken}
                    });

                }else {
                    //單店網頁版用
                    this.dataTokenWeb={dataToken: dataToken}
                    this.isTypeWeb=routerName
                    this.isShowPullDown = true
                }
            },
            oinCardPageEvent(obj) {
                let self = this;
                let event = obj.event;
                if (event === "reduceIsOinCardReadCount") {
                    self.isOinCardReadCount = 0
                }
            },

            /** 點擊排序 */
            clickSortBy: function(sortBy) {
                if (this.filter !== sortBy) {
                    this.filter = sortBy;

                    if (sortBy === SORT_BY_END_DATE) {
                        //以到期日排序時，遞增
                        this.order = ORDER_ASC;
                    } else if (sortBy === SORT_BY_GOT_DATE) {
                        //以取得日排序時，遞減
                        this.order = ORDER_DESC;
                    }

                    this.typeChanged(this.valueType);
                }
            },
            goBonusPointsPage(item) {
                let dataToken = this.$crypto.objectToURIComponent({
                    "usedType":  "BonusPointsPage",
                    "id":        item.id,
                })
                if(!this.isWeb){
                    this.$router.push({name: 'BonusPointsPage', query: {dataToken: dataToken}})
                }else {
                    //單店網頁版用
                    this.dataTokenWeb = {dataToken: dataToken}
                    this.isTypeWeb='BonusPointsPage'
                    this.isShowPullDown = true
                }
            },
            goTransferBonusPoints(item){
              let dataToken = this.$crypto.objectToURIComponent({
                  "usedType":  "TransferBonusPoints",
                  "id":        item.id,
              })

                if(!this.isWeb){
                    this.$router.push({name: 'TransferBonusPoints', query: {dataToken: dataToken}})
                }else {
                    //單店網頁版用
                    this.dataTokenWeb = {dataToken: dataToken}
                    this.isTypeWeb='TransferBonusPoints'
                    this.isShowDialog = true
                }
            },

            closePullDown(result) {
                this.isShowPullDown = false
                if (result) {
                    window.location.reload();
                }
            },

            onCommDialogClose(result) {
                this.isShowDialog = false;
                if(result){
                    //有轉贈成功時頁面刷新
                    window.location.reload();
                }
            },

            goCoupon(item) {
                let data = {
                    'id': '0',
                    'couponId': item.couponId,
                    'count': item.count,
                    'activeCategory': this.activeCategory,
                    'offersType': item.offersType,
                    'stageId': (item.couponType === 6 ? item.stageId.toString() : '0')
                }

                if (!this.isWeb) {
                    this.$router.push({
                        name: 'CouponPage',
                        query: data
                    })
                } else {
                    //單店網頁版用
                    this.dataTokenWeb = data
                    this.isTypeWeb = 'CouponPage'
                    this.isShowPullDown = true

                    localStorage.setItem('executeScanInfo', JSON.stringify({
                        event: 'goCoupon',
                        item: item,
                    }))
                }
            },

            goTransferCoupon(item){
                if(!this.isWeb){
                    this.$router.push({name: 'TransferCoupon', query:{'id': item.id, 'couponId': item.couponId, 'offersType': item.offersType}})

                }else {
                    //單店網頁版用
                    this.dataTokenWeb={'id': item.id, 'couponId': item.couponId, 'offersType': item.offersType}
                    this.isTypeWeb='TransferCoupon'
                    this.isShowDialog = true
                }
            },

            goCouponCard(item){

                if(!this.isWeb){
                    this.$router.push({ name: 'LoyaltyCardPage', query:{id:item.id, 'activeCategory': this.activeCategory}})

                }else {
                    //單店網頁版用
                    this.dataTokenWeb={id:item.id, 'activeCategory': this.activeCategory}
                    this.isTypeWeb='LoyaltyCardPage'
                    this.isShowPullDown = true
                }
            },
            couponPageEvent(obj) {
                let event = obj.event;
                let data = obj.data;

                if (event === "updateCount") {
                    let targetIndex = this.couponList.findIndex(item => {
                        return item.couponId === data.couponId;
                    })

                    if (targetIndex === -1) return

                    if (data.count > 0) {
                        this.couponList[targetIndex].count = data.count
                    } else {
                        this.couponList.splice(targetIndex, 1)
                    }
                }
            },
        },
        watch: {
            valueType() {
              this.typeChanged(this.valueType)
            },
            goToPageCardId() {
                if (this.goToPageCardId !== 0) {
                    this.isGoToPageOpened = false;
                }
            },
            '$store.state.publicCommDialogData.isShowDialog': function() {
              let routerName = this.$route.name
              if (routerName === 'Gift') {
                if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                  if (this.$store.state.publicCommDialogData.result &&
                      this.activeCategory === "coupon" &&
                      this.$store.state.publicCommDialogData.eventName === constDefine.ACTION_AMOUNT_EXCHANGE_COUPON) {
                    this.typeChanged('')
                    this.typeChanged('coupon')
                  }

                  this.$store.commit(mutationTypes.setPublicCommDialogData, {
                    isResultEvent: false,
                    eventName: "",
                  });
                }
              }
            }
        }
    }
</script>

<style lang="less" scoped src="../../../less/gift.less"/>